import { FadeUp } from './Motion.jsx';

export default function MedicalInfoCard({
  title = 'Medical information contact',
  org, address, phone, fax, email, docLabel, docHref,
}) {
  const telHref = `tel:${phone.replace(/[^\d+]/g, '')}`;

  return (
    <FadeUp>
      <section className="medinfo" aria-label={title}>
        <h2 className="medinfo-title">{title}</h2>

        <dl className="medinfo-rows">
          <div className="medinfo-row">
            <dt>Address</dt>
            <dd>
              {org}
              {address.map((line) => (
                <span key={line}><br />{line}</span>
              ))}
            </dd>
          </div>
          <div className="medinfo-row">
            <dt>Phone</dt>
            <dd><a href={telHref}>{phone}</a></dd>
          </div>
          {fax && (
            <div className="medinfo-row">
              <dt>Fax</dt>
              <dd>{fax}</dd>
            </div>
          )}
          <div className="medinfo-row">
            <dt>Email</dt>
            <dd><a href={`mailto:${email}`}>{email}</a></dd>
          </div>
        </dl>

        <div className="medinfo-actions">
          <a className="medinfo-btn" href={`mailto:${email}`}>Email medical information</a>
          {docHref && (
            <a className="medinfo-btn medinfo-btn--ghost" href={docHref} target="_blank" rel="noopener noreferrer">
              {docLabel} <span aria-hidden="true">&rarr;</span>
            </a>
          )}
        </div>
      </section>
    </FadeUp>
  );
}